import LabelValuePair from "@/models/LabelValuePair";
import OrderStatus from "@/models/enums/OrderStatus";

const orderStatusesHelper = {

	statuses(): Array<LabelValuePair<string, number>> {
		const x = this.statusesDescriptionDict();

		return [
			{
				value: OrderStatus.PartsOrdering,
				label: x[OrderStatus.PartsOrdering],		
			},
			{
				value: OrderStatus.PartsAwaiting,
				label: x[OrderStatus.PartsAwaiting]
			},
			{
				value: OrderStatus.VisitNegotiating,
				label: x[OrderStatus.VisitNegotiating]
			},
			{
				value: OrderStatus.VisitAwaiting,
				label: x[OrderStatus.VisitAwaiting]
			},
			{
				value: OrderStatus.VehicleAccepted,
				label: x[OrderStatus.VehicleAccepted]
			},
			{
				value: OrderStatus.VehicleInProgress,
				label: x[OrderStatus.VehicleInProgress]
			},
			{
				value: OrderStatus.ExtraNegotiating,
				label: x[OrderStatus.ExtraNegotiating]
			},
			{
				value: OrderStatus.VehicleCompleted,
				label: x[OrderStatus.VehicleCompleted]
			},
			{
				value: OrderStatus.Closed,
				label: x[OrderStatus.Closed]
			},
		];
	},

	/** list of statuses are allowed for new orders */
	/** [
	 * 		OrderStatus.PartsOrdering, 
	 * 		OrderStatus.PartsAwaiting,
	 * 		OrderStatus.VisitNegotiating,
	 * 		OrderStatus.VisitAwaiting,
	 * 		OrderStatus.VehicleAccepted,
	 * 		OrderStatus.VehicleInProgress
	 * 	] */
	newOrderStatuses(): Array<number> {
		return [
			OrderStatus.PartsOrdering,
			OrderStatus.PartsAwaiting,
			OrderStatus.VisitNegotiating,
			OrderStatus.VisitAwaiting,
			OrderStatus.VehicleAccepted,
			OrderStatus.VehicleInProgress
		];
	},

	statusesDescriptionDict() {
		return {
			1: 'Заказ запчастей',
			2: 'Ожидание запчастей',		
			3: 'Согласование визита',
			4: 'Ожидание визита',
			5: 'Автомобиль принят',
			6: 'Выполнение работ',
			7: 'Доп. согласование',
			8: 'Работы выполнены',
			9: 'Закрыт',
			10: 'Отказ'
		}
	}
}

export default orderStatusesHelper;